import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa' || 'mdi' || 'md'
  },
  theme: {
    themes: {
      light: {
        primary: '#9633DF',
        secondary: '#B4F04E',
        tertiary: '#DEEF58'
      }
    }
  }
})
